import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend/cjs';
import ChainedBackend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';

import { i18n } from '../../../next-i18next.config';

const isBrowser = typeof window !== 'undefined';
const isDev = process.env.NODE_ENV === 'development';
const cacheDuration = 3 * 60 * 60 * 1000; // 3 hours

export default {
  i18n,
  fallbackLng: {
    default: ['en-us'],
    'en-gb': ['en-us'],
    'en-ca': ['en-us'],
    'fr-ca': ['fr-fr'],
    'en-au': ['en-us'],
    'en-nl': ['en-us'],
    'en-it': ['en-us'],
    'en-sa': ['en-us'],
    'en-de': ['en-us'],
  },
  backend: {
    backendOptions: [
      {
        expirationTime: isDev ? 0 : cacheDuration,
      },
      {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
    ],
    backends: isBrowser ? [LocalStorageBackend, HttpBackend] : [],
  },
  use: isBrowser ? [ICU, initReactI18next, ChainedBackend] : [ICU],
  nonExplicitSupportedLngs: true,
  defaultNS: 'translation',
  ns: ['translation', 'trivia'],
  serializeConfig: false,
  lowerCaseLng: true,
  reloadOnPrerender: isDev,
  debug: false,
};
